import { useState } from 'react';
import { Dialog } from '@material-ui/core';
import styles from '../Payroll/Modals/PayrollModals.module.css';

interface DeleteConfirmModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const DeleteConfirmModal = ({ open, title, onClose, onConfirm }: DeleteConfirmModalProps) => {
  const [inputValue, setInputValue] = useState('');
  const activo = inputValue === 'ELIMINAR';

  const handleClose = () => {
    setInputValue('');
    onClose();
  };

  const handleConfirm = async () => {
    if (!activo) return;
    await onConfirm();
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="delete-confirm-dialog">
      <div className={styles.em_container}>
        <div className={styles.contenedorCerrarModal}>
          <div className={styles.cerrarModal} onClick={handleClose} />
        </div>
        <div className={styles.contenedorPrincipal}>
          <div className={styles.iconoEliminar} />
          <div className={styles.em_titulo} style={{ textAlign: 'center', padding: '0 24px' }}>{title}</div>
          <div className={styles.em_mensajePrtincipal}>
            <span>Una vez eliminado no podrás recuperar la información</span>
            <br />
            <span style={{ fontWeight: 700 }}>Escribe ELIMINAR para confirmar</span>
          </div>
          <div>
            <input
              className={styles.input}
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className={styles.em_contenedorBotones}>
        <button className={styles.em_botonCancelar} onClick={handleClose}>
          Cancelar
        </button>
        {activo ? (
          <button className={styles.em_botonConfirmarActivo} onClick={handleConfirm}>
            <div className={styles.em_iconoConfirmarEliminar} />
            <div>Confirmar</div>
          </button>
        ) : (
          <button className={styles.em_botonConfirmarInactivo} disabled>
            <div className={styles.em_iconoConfirmarEliminar} />
            <div>Confirmar</div>
          </button>
        )}
      </div>
    </Dialog>
  );
};

export default DeleteConfirmModal;
